import FeedbackQuestion from './FeedbackQuestion';
export default FeedbackQuestion;
